import { render, staticRenderFns } from "./HsabExpenseCardRowExpenseDetail.vue?vue&type=template&id=a484332e&scoped=true"
import script from "./HsabExpenseCardRowExpenseDetail.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseCardRowExpenseDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a484332e",
  null
  
)

export default component.exports